function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "p.0"
}, React.createElement("path", {
  d: "m0 0l500.0 0l0 500.0l-500.0 0l0 -500.0z",
  clipRule: "nonzero"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m0 0l500.0 0l0 500.0l-500.0 0z",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m113.35284 31.091705l0 0c0 -15.5358715 12.594315 -28.130184 28.13018 -28.130184l217.03395 0c7.460602 0 14.615631 2.9637074 19.891052 8.2391405c5.275421 5.2754335 8.239136 12.430455 8.239136 19.891045l0 437.8166c0 15.535858 -12.594299 28.130188 -28.130188 28.130188l-217.03395 0c-15.535866 0 -28.13018 -12.59433 -28.13018 -28.130188z",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m113.35284 31.091705l0 0c0 -15.5358715 12.594315 -28.130184 28.13018 -28.130184l217.03395 0c7.460602 0 14.615631 2.9637074 19.891052 8.2391405c5.275421 5.2754335 8.239136 12.430455 8.239136 19.891045l0 437.8166c0 15.535858 -12.594299 28.130188 -28.130188 28.130188l-217.03395 0c-15.535866 0 -28.13018 -12.59433 -28.13018 -28.130188z",
  fillRule: "evenodd"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m216.25175 30.566107l0 0c0 -3.2243671 2.613861 -5.838236 5.8382263 -5.838236l55.820023 0c1.5484009 0 3.0333862 0.61509895 4.1282654 1.70998c1.0948792 1.094881 1.7099915 2.5798607 1.7099915 4.128256l0 0l0 0c0 3.224371 -2.6138916 5.838236 -5.838257 5.838236l-55.820023 0c-3.2243652 0 -5.8382263 -2.613865 -5.8382263 -5.838236z",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m216.25175 30.566107l0 0c0 -3.2243671 2.613861 -5.838236 5.8382263 -5.838236l55.820023 0c1.5484009 0 3.0333862 0.61509895 4.1282654 1.70998c1.0948792 1.094881 1.7099915 2.5798607 1.7099915 4.128256l0 0l0 0c0 3.224371 -2.6138916 5.838236 -5.838257 5.838236l-55.820023 0c-3.2243652 0 -5.8382263 -2.613865 -5.8382263 -5.838236z",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m166.25104 30.566107l0 0c0 -3.9140244 3.172943 -7.0869694 7.086975 -7.0869694l0 0c1.8795776 0 3.6821747 0.74666023 5.0112457 2.0757256c1.3290558 1.3290653 2.0757294 3.1316624 2.0757294 5.011244l0 0c0 3.9140263 -3.172943 7.0869694 -7.086975 7.0869694l0 0c-3.914032 0 -7.086975 -3.172943 -7.086975 -7.0869694z",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m166.25104 30.566107l0 0c0 -3.9140244 3.172943 -7.0869694 7.086975 -7.0869694l0 0c1.8795776 0 3.6821747 0.74666023 5.0112457 2.0757256c1.3290558 1.3290653 2.0757294 3.1316624 2.0757294 5.011244l0 0c0 3.9140263 -3.172943 7.0869694 -7.086975 7.0869694l0 0c-3.914032 0 -7.086975 -3.172943 -7.086975 -7.0869694z",
  fillRule: "evenodd"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m319.575 30.566107l0 0c0 -3.9140244 3.172943 -7.0869694 7.086975 -7.0869694l0 0c1.8795776 0 3.68219 0.74666023 5.0112305 2.0757256c1.329071 1.3290653 2.0757446 3.1316624 2.0757446 5.011244l0 0c0 3.9140263 -3.172943 7.0869694 -7.086975 7.0869694l0 0c-3.914032 0 -7.086975 -3.172943 -7.086975 -7.0869694z",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m319.575 30.566107l0 0c0 -3.9140244 3.172943 -7.0869694 7.086975 -7.0869694l0 0c1.8795776 0 3.68219 0.74666023 5.0112305 2.0757256c1.329071 1.3290653 2.0757446 3.1316624 2.0757446 5.011244l0 0c0 3.9140263 -3.172943 7.0869694 -7.086975 7.0869694l0 0c-3.914032 0 -7.086975 -3.172943 -7.086975 -7.0869694z",
  fillRule: "evenodd"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m323.0293 30.566107l0 0c0 -2.0062733 1.6264038 -3.632679 3.6326904 -3.632679l0 0c0.96343994 0 1.8874207 0.38272667 2.568695 1.0639877c0.6812439 0.68125916 1.0639954 1.6052456 1.0639954 2.5686913l0 0c0 2.0062733 -1.6264038 3.632681 -3.6326904 3.632681l0 0c-2.0062866 0 -3.6326904 -1.6264076 -3.6326904 -3.632681z",
  fillRule: "evenodd"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m323.0293 30.566107l0 0c0 -2.0062733 1.6264038 -3.632679 3.6326904 -3.632679l0 0c0.96343994 0 1.8874207 0.38272667 2.568695 1.0639877c0.6812439 0.68125916 1.0639954 1.6052456 1.0639954 2.5686913l0 0c0 2.0062733 -1.6264038 3.632681 -3.6326904 3.632681l0 0c-2.0062866 0 -3.6326904 -1.6264076 -3.6326904 -3.632681z",
  fillRule: "evenodd"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m129.00255 54.105553l241.99489 0l0 384.1235l-241.99489 0z",
  fillRule: "evenodd"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 3,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m129.00255 54.105553l241.99489 0l0 384.1235l-241.99489 0z",
  fillRule: "evenodd"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m215.50575 467.67972l0 0c0 -9.950745 8.066681 -18.017456 18.01744 -18.017456l32.953613 0l0 0c4.7785034 0 9.361328 1.8982849 12.740265 5.277191c3.3789062 3.3789368 5.2771606 7.961731 5.2771606 12.740265l0 0l0 0c0 9.950775 -8.066681 18.017456 -18.017426 18.017456l-32.953613 0l0 0c-9.95076 0 -18.01744 -8.066681 -18.01744 -18.017456z",
  fillRule: "evenodd"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m215.50575 467.67972l0 0c0 -9.950745 8.066681 -18.017456 18.01744 -18.017456l32.953613 0l0 0c4.7785034 0 9.361328 1.8982849 12.740265 5.277191c3.3789062 3.3789368 5.2771606 7.961731 5.2771606 12.740265l0 0l0 0c0 9.950775 -8.066681 18.017456 -18.017426 18.017456l-32.953613 0l0 0c-9.95076 0 -18.01744 -8.066681 -18.01744 -18.017456z",
  fillRule: "evenodd"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m179.01137 467.67972l0 0c0 -2.2749634 1.8442383 -4.1192017 4.1192017 -4.1192017l0 0c1.0924835 0 2.140213 0.43399048 2.9127197 1.2064819c0.77249146 0.77249146 1.2064819 1.8202515 1.2064819 2.9127197l0 0c0 2.2749634 -1.844223 4.1192017 -4.1192017 4.1192017l0 0c-2.2749634 0 -4.1192017 -1.8442383 -4.1192017 -4.1192017z",
  fillRule: "evenodd"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m179.01137 467.67972l0 0c0 -2.2749634 1.8442383 -4.1192017 4.1192017 -4.1192017l0 0c1.0924835 0 2.140213 0.43399048 2.9127197 1.2064819c0.77249146 0.77249146 1.2064819 1.8202515 1.2064819 2.9127197l0 0c0 2.2749634 -1.844223 4.1192017 -4.1192017 4.1192017l0 0c-2.2749634 0 -4.1192017 -1.8442383 -4.1192017 -4.1192017z",
  fillRule: "evenodd"
});

var SvgAndroid = function SvgAndroid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0.0 0.0 500.0 500.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAndroid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android.175bff2a.svg";
export { ForwardRef as ReactComponent };